﻿import { Plugin } from 'ckeditor5';
import { LinkEditing, ButtonView } from 'ckeditor5';
import StatisticLinkEditing from './StatisticLinkEditing';
import { linkIcon, unlinkIcon } from './statisticLink/linkActionsView';

export default class StatisticLinkImageEditing extends Plugin {
    static get requires() {
        return [LinkEditing, StatisticLinkEditing];
    }

    static get pluginName() {
        return 'StatisticLinkImageEditing';
    }

    init() {
        const editor = this.editor;
        const viewDocument = this.editor.editing.view.document;
        const t = editor.t;

        //prevent opening of link toolbar when clicking linked image
        this.listenTo(viewDocument, 'click', (evt, data) => {
            if (this._isInlineImage(editor)) {
                data.preventDefault();
                evt.stop();
            }
        }, { priority: 'high' });

        editor.ui.componentFactory.add('linkImage', locale => {
            const linkButton = new ButtonView(locale);
            const linkCommand = editor.commands.get('openLinkPopup');
            linkButton.set({
                isEnabled: true,
                label: t('Link image'),
                icon: linkIcon,
                tooltip: true,
            });

            // Bind button to the command.
            linkButton.bind('isEnabled').to(linkCommand, 'isEnabled');

            this.listenTo(linkButton, 'execute', () => {
                editor.execute('openLinkPopup');
            });

            return linkButton;
        });

        editor.ui.componentFactory.add('unlinkImage', locale => {
            const unlinkButton = new ButtonView(locale);
            const linkCommand = editor.commands.get('openLinkPopup');

            unlinkButton.set({
                isEnabled: true,
                label: t('Unlink image'),
                icon: unlinkIcon,
                tooltip: true,
            });

            // Bind button to the command.
            unlinkButton.bind('isEnabled').to(linkCommand, 'isEnabled');
            unlinkButton.bind('isVisible').to(linkCommand, 'value', value => !!value);

            this.listenTo(unlinkButton, 'execute', () => {
                editor.execute('unlink');
            });

            return unlinkButton;
        });

        editor.config._config.image.toolbar.splice(1, 0, 'unlinkImage');
    }

    _isInlineImage(editor) {
        var range = editor.model.document.selection.getFirstRange();
        for (var value of range.getWalker()) {
            if (value.item && value.item.name === 'imageInline') {
                return true;
            }
        }

        return false;
    }
};